module.exports = __webpack_public_path__ + "img/yx.32d4aff9.png";